import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CmsPage, CxComponent } from '@app/core/models/atomics.model';
import { environment } from '@environments/environment';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CmsConnector {
  constructor(private http: HttpClient) {}

  getComponent(uid: string, model: string, type: string): Observable<CxComponent> {
    const url = `${environment.apiService}/cms/component?uid=${uid}&model=${model}`;
    return this.http
      .get<unknown>(url)
      .pipe(map(data => ({ type: type.replace(/^CX_COMPONENT\./, ''), data }) as CxComponent));
  }

  getPage(pageId: string): Observable<CmsPage> {
    const url = `${environment.apiService}/cms/page?pageId=${pageId}`;
    return this.http.get<CmsPage>(url).pipe(
      map(page => ({
        ...page,
        sections: page.sections.map(section => ({
          ...section,
          components: section.components.map(component => ({
            ...component,
            type: component?.type?.replace(/^CX_COMPONENT\./, ''),
          })),
        })),
      })),
      catchError(() => {
        return of({
          componentType: 'not-found',
          id: 'not-found',
          title: 'Não Encontrado',
          sections: [],
        });
      }),
    );
  }
}
